import { injectIntl } from 'react-intl';

import CloseButton from './CloseButton';

export default injectIntl(CloseButton);
